import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CheckCircleOutlined,
  CloseOutlined,
  LineChartOutlined,
  PhoneOutlined,
  UserSwitchOutlined,
} from "@ant-design/icons";
import { Spin } from "antd";

import { loadSummary } from "../../slice";
import { selectSummary } from "../../selector";
import type { DashboardStat, DashboardSummary } from "../../types";
import {
  StatBottomRow,
  StatCard,
  StatIconCircle,
  StatLabel,
  StatTopRow,
  StatValue,
  StatsGrid,
} from "../../style";

const stats: DashboardStat[] = [
  {
    key: "total",
    icon: <PhoneOutlined />,
    label: "Total calls",
    value: "0",
  },
  {
    key: "successful",
    icon: <CheckCircleOutlined />,
    label: "Successful calls",
    value: "0",
  },
  {
    key: "unsuccessful",
    icon: <CloseOutlined />,
    label: "Unsuccessful calls",
    value: "0",
  },
  {
    key: "rate",
    icon: <LineChartOutlined />,
    label: "Success rate",
    value: "0%",
  },
  {
    key: "followups",
    icon: <UserSwitchOutlined />,
    label: "Follow-up Calls",
    value: "0",
  },
];

function valuesFromSummary(s: DashboardSummary): Record<string, string> {
  return {
    total: String(s.total_calls),
    successful: String(s.successful_calls),
    unsuccessful: String(s.unsuccessful_calls),
    rate: `${s.success_rate}%`,
    followups: String(s.follow_up_calls),
  };
}

export default function StatsRow() {
  const dispatch = useDispatch();
  const { data, loading } = useSelector(selectSummary);

  useEffect(() => {
    dispatch(loadSummary());
  }, [dispatch]);

  const values = data ? valuesFromSummary(data) : null;

  return (
    <Spin spinning={loading}>
      <StatsGrid gap={14} wrap="wrap">
        {stats.map((s) => (
          <StatCard key={s.key}>
            <StatTopRow align="center" justify="space-between">
              <StatIconCircle align="center" justify="center">
                {s.icon}
              </StatIconCircle>
            </StatTopRow>
            <StatLabel>{s.label}</StatLabel>
            <StatBottomRow align="center" justify="space-between" gap={10}>
              <StatValue level={3}>{values?.[s.key] ?? s.value}</StatValue>
            </StatBottomRow>
          </StatCard>
        ))}
      </StatsGrid>
    </Spin>
  );
}
